// extracted by css-extract-rspack-plugin
export default {"label":"thirdPartyTrackingSetting_label__i2Orn"};